/**
 * @generated SignedSource<<538e34ac235a9f2b367a44894c61292e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveTemplateMutation$variables = {
  name: string;
};
export type RemoveTemplateMutation$data = {
  readonly removeTemplate: string | null | undefined;
};
export type RemoveTemplateMutation = {
  response: RemoveTemplateMutation$data;
  variables: RemoveTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  }
],
v2 = {
  "alias": null,
  "args": (v1/*: any*/),
  "kind": "ScalarField",
  "name": "removeTemplate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveTemplateMutation",
    "selections": [
      (v2/*: any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveTemplateMutation",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": null,
        "handle": "deleteRecord",
        "key": "",
        "kind": "ScalarHandle",
        "name": "removeTemplate"
      }
    ]
  },
  "params": {
    "cacheID": "1ac6cd6b7922166e5e8acb90c3fb7708",
    "id": null,
    "metadata": {},
    "name": "RemoveTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveTemplateMutation(\n  $name: String!\n) {\n  removeTemplate(name: $name)\n}\n"
  }
};
})();

(node as any).hash = "596d184f47b893136f74fe8061310478";

export default node;
